__turbopack_context__.v({
  "testimonialReview": "_-module__rfe1Fa__testimonialReview",
});
